import { FC, memo, useMemo } from "react";
import { iTableConfigItem } from "@components/Table/TableConfig";
import FeedbackTable from "@pages/ItemDetails/parts/CardOpenEndedFeedback/FeedbackTable";
import { Highlight } from "@pages/ItemDetails/parts/CardOpenEndedFeedback/HighlightExperience";

const HighlightTable: FC<{
    isLike?: boolean;
    items: Highlight[];
}> = ({
    items,
    isLike = false,
}) => {
    const config = useMemo(
        (): iTableConfigItem[] => [
            {
                key: 'name',
                title: (
                    <div className={`CardOpenEndedFeedback__table-header is-${isLike ? 'like' : 'dislike'}`}>
                        HIGHLIGHTING AS {isLike ? 'LIKE' : 'DISLIKE'}
                    </div>
                ),
                Value: ({ index }) => (<>
                    {items[index].name}
                </>),
            },
            {
                key: 'value',
                title: '%',
                Value: ({ index }) => (<>
                    {Number(items[index].value)}%
                </>),
                styles: {
                    cell: {
                        flex: `0 0 50px`,
                        justifyContent: 'center',
                    }
                }
            },
        ],
        [isLike, items]
    );

    return (
        <div className="CardOpenEndedFeedback__column">
            <FeedbackTable
                config={config}
                itemsCount={items.length}
                rowHeight={30}
                rowMinHeight={30}
            />
        </div>
    );
}

export default memo(HighlightTable);